import React, { useState, useEffect } from 'react';
import { Constants } from '../Constants';

const ContainerInfoInputCard = (props) => {
  	const [ContainerInfo, updateContainerInfoArray] = useState(JSON.parse(JSON.stringify(Constants.defaultContainerInputData)));

	useEffect(
		() => {
			updateContainerInfoArray(props.values);
		},
		[props.values]
	);

	const handleChange = (event) => {
		var nameSplitArray = event.target.name.split(".");
		
		var key = nameSplitArray[nameSplitArray.length-1];
		var value = event.target.value;
		
		props.onUpdate(props.id, key, value);		
	}
	
	// RJM 11/04/2020: bound to Models\Freight\Container\Container.cs > ContainerViewModel
	var baseInputName = props.baseInputName;
	var bookingNumberInput = baseInputName + "[" + props.id + "].bookingNumber";
	var sizeInput = baseInputName + "[" + props.id + "].size";
	var containerSize = Constants.ContainerSize[props.values["size"]];
	var containerEditInput = baseInputName + "[" + props.id + "].containerEditId";

	// Container number not known when posting this. Container number is written on the container
	// itself, and will be known once the carrier picks the container up from the port.
	// var ContainerNumeberInput = baseInputName + "[" + props.id + "].Model";

	var removeButton;
	
  	return (
		<div className="col-sm-12 col-md-6 mb-2">
			<div className="card border border-light shadow-3 p-2">
				<div className="row align-items-center mb-2">
					<div className="col-sm-6">                    
						<strong>Container #{parseInt(props.id,10) + 1}</strong>
					</div>
					<div className="col-sm-6">
						<div className="row">
							<div className="col-auto ml-auto">
								<button type="button" className="btn btn-danger" onClick={() => props.onRemove(parseInt(props.id))}>
									Remove Container
								</button>
							</div>
						</div>
					</div>
					<div className="w-100"></div>
					<div className="col-sm-12 col-md-6">
						<label className="control-label">Booking Number</label>                
						<input required name={bookingNumberInput} className="form-control" value={props.values["bookingNumber"]}
							onChange={evt => handleChange(evt)}/>
					</div>
					<div className="col-sm-12 col-md-6">
						<label type="text" className="control-label">Container size</label>
						<input type="text" className="form-control" disabled value={Constants.ContainerSize[props.containerSize].displayValue}/>
					</div>
					{props.editMode &&
						<input type="hidden" value={props.values["containerEditId"]} name={containerEditInput}/>
					}
				</div>
			</div>
		</div>
	);
}

export { ContainerInfoInputCard };